<template>
  <div class='flex gap-2'>
    <ContextualRouterLink :to="collection.getEditUrl(props.item)" class="text-jananavy-600 hover:text-jananavy-900 font-medium">
      Edit <span class="sr-only">{{ collection.getName(props.item) }}</span>
    </ContextualRouterLink>
    <a class="text-jananavy-600 hover:text-jananavy-900 font-medium flex gap-1 items-center" :href='pdfUrl' target='_blank'>
      <span>Export <span class="sr-only">{{ collection.getName(props.item) }}</span> PDF</span> <LoadingIcon class='w-3 h-3' v-if='state.loading' />
    </a>
  </div>
</template>

<script setup>

import { reactive } from 'vue';

import { getCollection } from '@/kernel/collections';
import { getPDFExportUrl } from '@/kernel/report';

import ContextualRouterLink from '@/components/links/contextual-router-link.vue';
import LoadingIcon from '@/components/icons/loading-icon.vue';

const props = defineProps({
  column: Object,
  item: Object,
  collection: String
});

const collection = getCollection(props.collection);

const pdfUrl = getPDFExportUrl(collection.getPDFExportUrl(props.item));

const state = reactive({
  loading: false
});

let timeout = null;

const showSpinner = () => {
  state.loading = true;

  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    state.loading = false;
    timeout = null;
  }, 1000);
}

</script>
